import styled from 'styled-components'

import MainLayout from '../../layouts/MainLayout'
import { mq, sizes } from '../../theme'
import { RelatedProductsBlock } from '../../components/molecules/RelatedProductsBlock/styled'
import TagsCloud from '../../components/molecules/TagsCloud'
import Pagination from '../../components/molecules/Pagination'
import CardsBlock from '../../components/molecules/CardsBlock'
import HeroBanner from '../../components/molecules/HeroBanner'
import Html from '../../components/atoms/Html'

export const Layout = styled(MainLayout)`
  @media ${mq(sizes.tablet)} {
    & ${RelatedProductsBlock} {
      border-top-left-radius: 2rem;
      border-top-right-radius: 2rem;
    }
  }
`

export const Hero = styled(HeroBanner)`
  padding: 0 1.5rem;

  @media ${mq(sizes.tablet)} {
    padding: 0;
  }
`

export const TextsContainer = styled.div`
  text-align: center;
  padding: 4rem 2rem 2rem 2rem;

  @media ${mq(sizes.tablet)} {
    padding: 4rem 4rem 2rem 4rem;
  }
`

export const MainContent = styled.div`
  display: flex;
  flex-direction: column;
`

export const Title = styled.h2`
  ${({ theme }) => theme.textStyles.titleH1}
  margin: 0;
  color: ${({ theme }) => theme.colors.arapawa};
`

export const Subtitle = styled.h4`
  ${({ theme }) => theme.textStyles.titleH4}
  margin: 1rem 0 0 0;
  color: ${({ theme }) => theme.colors.bismark};
`

export const CardBlock = styled(CardsBlock)`
  padding-top: 0;
  padding-bottom: 0;

  & div {
    margin-top: 0;
  }
`

export const PaginationBlock = styled(Pagination)`
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid ${({ theme }) => theme.colors.gainsboro};
`

export const TagCloud = styled(TagsCloud)`
  padding-bottom: 4rem;
  padding-top: 0;

  & h2 {
    border-top: 1px solid ${({ theme }) => theme.colors.gainsboro};
    padding-top: 2rem;
    width: 100%;
    text-align: start;
  }

  & nav {
    justify-content: flex-start;
  }

  @media ${mq(sizes.mobile)} {
    padding-bottom: 5rem;
    & h2 {
      padding-top: 3rem;
    }
  }
`

export const TextsBlock = styled(Html)`
  border-top: 1px solid ${({ theme }) => theme.colors.gainsboro};
  padding: 4rem 1.5rem;

  @media ${mq(sizes.tablet)} {
    padding: 4rem 3rem;
  }

  & h4 {
    ${({ theme }) => theme.textStyles.titleH4}
    margin: 0 0 2rem 0;
    color: ${({ theme }) => theme.colors.arapawa};
  }

  & p {
    ${({ theme }) => theme.textStyles.textMedium}
    color: ${({ theme }) => theme.colors.bismark};
  }
`
